// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav-pills>li>a[data-v-2cf6a89c],.nav-pills>li>a[data-v-2cf6a89c]:focus{color:grey}.nav-pills>li>a[data-v-2cf6a89c]:hover{color:#fff;background-color:#a9a9a9}.nav-pills>li>a.active[data-v-2cf6a89c],.nav-pills>li>a.active[data-v-2cf6a89c]:focus,.nav-pills>li>a.active[data-v-2cf6a89c]:hover{color:#fff;background-color:grey}", ""]);
// Exports
module.exports = exports;
